import { createSelector } from 'reselect';
import { standortStateSelector } from '../standort';
import _ from 'lodash';
import { extraParamsSelector } from '../util';

const serviceByUrlSelector = createSelector([standortStateSelector], standortState => standortState.service);

const serviceUrlSelector = createSelector([extraParamsSelector], params => {
    const { serviceUrl } = params;
    if (_.isNil(serviceUrl) || !_.isString(serviceUrl) || _.isEmpty(serviceUrl)) {
        throw new Error(`Expected valid serviceUrl, instead got: ${serviceUrl}`);
    }
    return serviceUrl;
});

export const serviceSelector = createSelector(
    [serviceByUrlSelector, serviceUrlSelector],
    (serviceByUrl, serviceUrl) => serviceByUrl?.[serviceUrl] ?? {}
);
